/** Window event on which the editor reloads the link's data (see EditSessionLayout). */
export const LINK_SESSIONS_RELOAD_EVENT = "fetch-link-sessions-info";

/** Asks the editor to reload the link's data, which also discards its pending changes. */
export const requestLinkSessionsReload = () => {
  window.dispatchEvent(new Event(LINK_SESSIONS_RELOAD_EVENT));
};
